import { __assign } from './../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import { useTranslation } from 'react-i18next';
import Button from '../Atoms/Button.js';
import ItemCard from '../Components/Organisms/LandingScreenMenu/Web/item-card.component.js';

function LandingScreenMenu(_a) {
    var classes = _a.classes, menu = _a.menu, onViewMenuClick = _a.onViewMenuClick, onItemClick = _a.onItemClick, description = _a.description, title = _a.title, imageComponent = _a.imageComponent;
    var t = useTranslation().t;
    var handleItemClick = function (item) {
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
    };
    return (React__default.createElement("div", { className: classNames('landing-screen-menu', classes) },
        React__default.createElement(Typography, { variant: "displayText", classes: "landing-screen-menu__title" }, title ? title : t('landingScreen.ourMenu')),
        React__default.createElement(Typography, { variant: "bodyTextOne", classes: "landing-screen-menu__description" }, description),
        React__default.createElement("div", { className: "landing-screen-menu__cards" }, menu.map(function (item) { return (React__default.createElement(ItemCard, __assign({}, item, { key: item.id, onClick: function () { return handleItemClick(item); }, imageComponent: imageComponent }))); })),
        React__default.createElement(Button, { variant: "solid", size: "md", classes: "landing-screen-menu__view-menu-button", onClick: onViewMenuClick }, t('landingScreen.viewMenu'))));
}

export { LandingScreenMenu as default };
//# sourceMappingURL=LandingScreenMenu.js.map
